import React from "react";
import { Link } from "react-router-dom";
import { Flex, Image } from "antd";
import {
  LocateIcon,
  PhoneCallIcon,
  SendIcon,
  Facebook,
  Twitter,
  Instagram,
  Youtube,
} from "lucide-react";
import { withTranslation } from "react-i18next";
import logo from "../../assets/images/logor.png";
import payment from "../../assets/images/footer/Payment.png";
import footer1 from "../../assets/images/footer/svg1.png";
import footer2 from "../../assets/images/footer/svg2.png";
import footer3 from "../../assets/images/footer/svg3.png";

const FooterItem = ({ icon: Icon, title, text }) => (
  <div className="w-full md:w-1/3 mb-8 md:mb-0">
    <div className="flex items-start space-x-4">
      <div className="w-16">
        <Image preview={false} src={Icon} className="w-12 h-12 text-blue-600" />
      </div>
      <div>
        <h4 className="text-2xl font-semibold mb-2">{title}</h4>
        <p className="text-gray-600">{text}</p>
      </div>
    </div>
  </div>
);

// Define navigation links
const accountLinks = [
  { label: "Wishlist", route: "/favorites" },
  { label: "Mycart", route: "/cart" },
  { label: "TrackOrder", route: "/orders" },
  { label: "Orders", route: "/orders" },
];

const helpLinks = [
  { label: "AboutUs", route: "/" },
  { label: "CONTACTUS", route: "/" },
  { label: "PrivacyPolicy", route: "/" },
];

const Footer = ({ t, i18n }) => {
  return (
    <footer className="w-full">
      {/* Info Section */}
      <div className="bg-white py-12">
        <div className="container mx-auto px-4">
          <Flex className="flex-col md:flex-row gap-8">
            <FooterItem icon={footer1} title={t("f1")} text={t("f2")} />
            <FooterItem icon={footer2} title={t("f3")} text={t("f4")} />
            <FooterItem icon={footer3} title={t("f5")} text={t("f6")} />
          </Flex>
          <hr className="my-8" />
        </div>
      </div>

      {/* Main Footer */}
      <div className="bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            {/* Company Info */}
            <div className="md:col-span-7">
              <img
                src={logo}
                width={120}
                height={100}
                alt="Company Logo"
                className="mb-6"
              />
              <Flex vertical className="space-y-3">
                <Flex align="center" gap={8}>
                  <LocateIcon size={20} />
                  <span>
                    C.R. No. 337167 - P.O.Box: 2106 Safat 13022 Kuwait
                  </span>
                </Flex>
                <Flex align="center" gap={8}>
                  <PhoneCallIcon size={20} />
                  <span>{i18n.language === "ar" ? "٢٤٨٢٣٨٨٧ ٩٦٥+" : "+965 24823887"}</span>
                </Flex>
                <Flex align="center" gap={8}>
                  <SendIcon size={20} />
                  <span>info@order-fs.online</span>
                </Flex>
              </Flex>
            </div>

            {/* Account Links */}
            <div className="md:col-span-3">
              <h2 className="text-2xl font-semibold mb-4">{t("Account")}</h2>
              <div className="space-y-2">
                {accountLinks.map(({ label, route }) => (
                  <Link
                    key={label}
                    to={route}
                    className="text-decoration-none block text-gray-600 hover:text-gray-900"
                  >
                    {t(label)}
                  </Link>
                ))}
              </div>
            </div>

            {/* Help Center Links */}
            <div className="md:col-span-2">
              <h2 className="text-2xl font-semibold mb-4">{t("HelpCenter")}</h2>
              <div className="space-y-2">
                {helpLinks.map(({ label, route }) => (
                  <Link
                    key={label}
                    to={route}
                    className="text-decoration-none block text-gray-600 hover:text-gray-900"
                  >
                    {t(label)}
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <hr className="my-8" />
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="bg-white py-4">
        <div className="container mx-auto px-4">
          <Flex justify="space-between" align="center" className="flex-col md:flex-row gap-4">
            <p className="text-xl text-gray-600">{t("Copy")}</p>
            <img src={payment} alt="Payment Methods" className="h-8" />
            <Flex gap={12}>
              {[Facebook, Twitter, Instagram, Youtube].map((Icon, index) => (
                <a
                  key={index}
                  href="/"
                  className="text-gray-600 hover:text-gray-900 transition-colors"
                  aria-label={Icon.name}
                >
                  <Icon size={24} />
                </a>
              ))}
            </Flex>
          </Flex>
        </div>
      </div>
    </footer>
  );
};

export default withTranslation()(Footer);
